const data = [
  {
    name: "Menu",
    path: null,
    children: [
      { name: "Visão Geral", icon: "mdi-home", route: "/home" },
      { name: "Vendas", icon: "mdi-percent-outline", route: "/historico-vendas" },
      { name: "Máquinas", icon: "mdi-washing-machine", route: "/maquinas" },
      { name: "Clientes", icon: "mdi-account-plus", route: "/clientes" },
      { name: "Preço Dinâmico", icon: "mdi-clock-outline", route: "/preco-dinamico" },
      { name: "Cupons", icon: "mdi-ticket-percent-outline", route: "/cupons" },
      { name: "Combos", icon: "mdi-package-variant-closed", route: "/combos" },
      { name: "Cashback", icon: "mdi-cash-refund", route: "/cashback" },
      { name: "Upbox", icon: "mdi-chip", route: "/upboxes" },
      { name: "Totens de Pagamento", icon: "mdi-credit-card-marker-outline", route: "/totens" },
      { name: "Parâmetros", icon: "mdi-cog-outline", route: "/parametros" },
     // { 
 // name: "Notas Fiscais", 
 // icon: "mdi-file-document-outline", 
 // route: "/notas-fiscais", 
 // active: false, // Controle para o v-list-group expandir
 // children: [

  //  { 
   //   name: "Configurações", 
   //   icon: "mdi-cog-outline", 
   //   route: "/notas-fiscais/configuracoes" // Cai na NfseConfig
  //  }
    //    ]
  //    }
 ],
  },
 ];

export default [...data];